function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState, useRef } from "react";
import moment from "moment-timezone";
import { Table, Button, Modal, Form, Row, Col, Tabs, Tab, Card, InputGroup, Badge } from "react-bootstrap";
import "./PayrollCalculator.css";
import { Field, FieldArray, Form as FormikForm, Formik, getIn } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { MdAccessTime, MdArrowForward } from "react-icons/md";
import { GoChevronDown } from "react-icons/go";
import { FaRegCalendar, FaCheckCircle, FaRegCalendarAlt, FaRegCheckCircle, FaUser, FaCalendarAlt, FaCheck, FaRegClock } from "react-icons/fa";
import { FiDollarSign } from "react-icons/fi";
import PaymentHistory from "./PaymentHistory";
import MemberProfile from "./MemberProfile";
import PayrollPeriodPicker, { getCurrentPeriodDates } from "./PayrollPeriodPicker";
import DatePicker from "react-datepicker";
import { PAYROLL_SETUP_DETAILS_QUERY, ADD_PAYROLL_SETUP_MUTATION, PAYROLL_SUMMARY_QUERY, PAYMENT_MARK_AS_PAID_MUTATION, PAYROLL_HEADER_SUMMARY_QUERY, PAYROLL_SUMMARY_EXPORT_QUERY, MEMBER_LIST_FOR_PAYROLL_QUERY, MEMBER_TIME_ENTRIES_FOR_SUMMARY_QUERY } from "./query";
import { FilterContext, UserContext } from "../index";
import { useQuery, useLazyQuery, useMutation, useApolloClient } from "@apollo/client";
import Loader from "./../Loader/Loader";
import { toast } from "react-toastify";
import { TimeFilter } from "./../ProjectReport/DateFilter";
import { arrayToStringOutput, startOfDayCheck, endOfDayCheck } from "./../SideMenu/Header";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { HiDownload } from "react-icons/hi";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { salaryType, salaryMetric, currency } from "./PayrollDropdownDatas";
import { payrollCurrenciesList } from "./../TimesheetSettings/data";
import Tooltip from "react-bootstrap/Tooltip";
import { FaPercent } from "react-icons/fa";
import { MdInfo } from "react-icons/md";
var LIMIT = 15;
var PayrollCalculator = function PayrollCalculator(props) {
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    teamId = _React$useContext2.teamId,
    organisationId = _React$useContext2.organisationId,
    startDate = _React$useContext2.startDate,
    endDate = _React$useContext2.endDate,
    organisationSettings = _React$useContext2.organisationSettings,
    organisationUserCount = _React$useContext2.organisationUserCount,
    organisationBilling = _React$useContext2.organisationBilling,
    role = _React$useContext2.role,
    from = _React$useContext2.from;
  var _useState = useState(role == "Admin" ? "PayrollSummary" : "MemberProfile"),
    _useState2 = _slicedToArray(_useState, 2),
    payrollKey = _useState2[0],
    setPayrollKey = _useState2[1];
  var _useState3 = useState("$"),
    _useState4 = _slicedToArray(_useState3, 2),
    currencySymbol = _useState4[0],
    setCurrencySymbol = _useState4[1];
  useEffect(function () {
    if (role != null) {
      setPayrollKey(role == "Admin" ? "PayrollSummary" : "MemberProfile");
    }
  }, [role]);
  useEffect(function () {
    if (organisationSettings.payrollCurrency) {
      var _currency = payrollCurrenciesList.find(function (type) {
        return type.value === organisationSettings.payrollCurrency;
      });
      setCurrencySymbol(_currency.symbol);
    }
  }, [organisationSettings]);
  var momentNow = moment().format("YYYY-MM-DD HH:mm:ss");
  return /*#__PURE__*/React.createElement("div", {
    className: "payroll-root"
  }, role == "Admin" ? /*#__PURE__*/React.createElement(Tabs, {
    className: "payroll-tab-list",
    activeKey: payrollKey,
    onSelect: function onSelect(k) {
      return setPayrollKey(k);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "PayrollSummary",
    title: "Payroll Summary"
  }, /*#__PURE__*/React.createElement(PayrollSummary, {
    key: payrollKey,
    setPayrollKey: setPayrollKey,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings,
    organisationId: organisationId,
    role: role,
    user: user,
    payrollKey: payrollKey,
    currencySymbol: currencySymbol,
    momentNow: momentNow
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "PayrollSetup",
    title: "Payroll Setup"
  }, /*#__PURE__*/React.createElement(PayrollSetup, {
    key: payrollKey,
    organisationId: organisationId,
    user: user,
    payrollKey: payrollKey,
    currencySymbol: currencySymbol,
    momentNow: momentNow,
    role: role,
    organisationSettings: organisationSettings
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "PaymentHistory",
    title: "Payment History"
  }, /*#__PURE__*/React.createElement(PaymentHistory, {
    key: payrollKey,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings,
    organisationId: organisationId,
    payrollKey: payrollKey,
    currencySymbol: currencySymbol,
    role: role
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "MemberProfile",
    title: "Member Profile"
  }, /*#__PURE__*/React.createElement(MemberProfile, {
    key: payrollKey,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings,
    organisationId: organisationId,
    payrollKey: payrollKey,
    currencySymbol: currencySymbol,
    role: role
  }))) : /*#__PURE__*/React.createElement(MemberProfile, {
    key: payrollKey,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings,
    organisationId: organisationId,
    payrollKey: payrollKey,
    currencySymbol: currencySymbol
  }));
};
var PayrollSetup = function PayrollSetup(props) {
  var _payrollSetupData$pay4;
  var organisationId = props.organisationId,
    user = props.user,
    payrollKey = props.payrollKey,
    currencySymbol = props.currencySymbol,
    momentNow = props.momentNow,
    role = props.role,
    organisationSettings = props.organisationSettings;
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    editPayrollShow = _useState6[0],
    setEditPayrollShow = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isAllLoaded = _useState8[0],
    setIsAllLoaded = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isLoadingMore = _useState10[0],
    setIsLoadingMore = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    userList = _useState12[0],
    setUserList = _useState12[1];
  var _useState13 = useState({
      label: "All Members",
      value: null
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    userParameterCheck = _useState14[0],
    setUserParameterCheck = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    editedPayrollDetails = _useState16[0],
    setEditedPayrollDetails = _useState16[1];
  var handleEditPayrollClose = function handleEditPayrollClose() {
    return setEditPayrollShow(false);
  };
  var handleEditPayrollShow = function handleEditPayrollShow(payrollData) {
    setEditPayrollShow(payrollData);
  };
  var _useLazyQuery = useLazyQuery(PAYROLL_SETUP_DETAILS_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getPayrollSetupData = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    payrollSetupData = _useLazyQuery2$.data,
    payrollSetupError = _useLazyQuery2$.error,
    payrollSetupLoading = _useLazyQuery2$.loading,
    payrollSetupFetchMore = _useLazyQuery2$.fetchMore;
  var _useLazyQuery3 = useLazyQuery(MEMBER_LIST_FOR_PAYROLL_QUERY),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getMemberListData = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    memberListData = _useLazyQuery4$.data,
    memberListError = _useLazyQuery4$.error,
    memberListLoading = _useLazyQuery4$.loading;
  useEffect(function () {
    if (payrollKey == "PayrollSetup") {
      getMemberListData({
        variables: {
          organisationId: organisationId,
          date: momentNow
        },
        skip: !organisationId
      });
      getPayrollSetupData({
        variables: {
          organisationId: organisationId,
          limit: LIMIT,
          offset: 0,
          userId: userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
          date: momentNow
        },
        skip: !organisationId
      });
    }
  }, [payrollKey]);
  useEffect(function () {
    getPayrollSetupData({
      variables: {
        organisationId: organisationId,
        limit: LIMIT,
        offset: 0,
        userId: userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
        date: momentNow
      },
      skip: !organisationId
    });
    setIsAllLoaded(false);
    setIsLoadingMore(false);
  }, [userParameterCheck]);
  useEffect(function () {
    if (memberListData !== null && memberListData !== void 0 && memberListData.memberListForPayroll.length) {
      var _memberListData$membe;
      var memberData = memberListData === null || memberListData === void 0 ? void 0 : (_memberListData$membe = memberListData.memberListForPayroll) === null || _memberListData$membe === void 0 ? void 0 : _memberListData$membe.map(function (item) {
        var userId = item.userId,
          displayName = item.displayName;
        return {
          label: displayName,
          value: userId
        };
      });
      setUserList([{
        label: "All Members",
        value: null
      }].concat(_toConsumableArray(memberData)));
    }
  }, [memberListData]);
  function getInitials() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var words = name.trim().split(/\s+/); // split by space

    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    } else if (words.length === 1 && words[0].length > 0) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return "";
  }

  // React.useEffect(() => {
  //   setIsAllLoaded(false);
  //   setIsLoadingMore(false);
  // }, [userParameterCheck, dates]);

  React.useEffect(function () {
    var _payrollSetupData$pay, _payrollSetupData$pay2;
    if ((payrollSetupData === null || payrollSetupData === void 0 ? void 0 : (_payrollSetupData$pay = payrollSetupData.payrollSetupDetails) === null || _payrollSetupData$pay === void 0 ? void 0 : _payrollSetupData$pay.length) !== 0 && (payrollSetupData === null || payrollSetupData === void 0 ? void 0 : (_payrollSetupData$pay2 = payrollSetupData.payrollSetupDetails) === null || _payrollSetupData$pay2 === void 0 ? void 0 : _payrollSetupData$pay2.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [payrollSetupData === null || payrollSetupData === void 0 ? void 0 : payrollSetupData.payrollSetupDetails]);
  var handleLoadMore = function handleLoadMore() {
    var _payrollSetupData$pay3;
    if (payrollSetupLoading) return;
    setIsLoadingMore(true);
    payrollSetupFetchMore({
      variables: {
        offset: payrollSetupData === null || payrollSetupData === void 0 ? void 0 : (_payrollSetupData$pay3 = payrollSetupData.payrollSetupDetails) === null || _payrollSetupData$pay3 === void 0 ? void 0 : _payrollSetupData$pay3.length
      },
      updateQuery: function updateQuery(prev, _ref) {
        var _fetchMoreResult$payr, _fetchMoreResult$payr2;
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$payr = fetchMoreResult.payrollSetupDetails) === null || _fetchMoreResult$payr === void 0 ? void 0 : _fetchMoreResult$payr.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$payr2 = fetchMoreResult.payrollSetupDetails) === null || _fetchMoreResult$payr2 === void 0 ? void 0 : _fetchMoreResult$payr2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          payrollSetupDetails: [].concat(_toConsumableArray(prev.payrollSetupDetails), _toConsumableArray(fetchMoreResult.payrollSetupDetails))
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-help"
  }, /*#__PURE__*/React.createElement(MdInfo, {
    className: "payroll-summary-card-help-icon"
  }), "Visit", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://workfolio.tawk.help/article/introducing-payroll-calculator-workfolio",
    target: "_blank"
  }, "this article"), " ", "to learn about the Payroll Calculator."), /*#__PURE__*/React.createElement(Card, {
    className: "p-4  mb-4 shadow-sm member-profile-payroll-details-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-header-wrapper"
  }, /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-header"
  }, "Employee Payroll Setup"), /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-sub-title"
  }, "Configure payroll settings for each employee")), /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userList
    //defaultMenuIsOpen={true}
    ,
    menuPosition: "fixed",
    className: "payroll-setup-modal-dropdown"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-table-div"
  }, payrollSetupLoading ? /*#__PURE__*/React.createElement(Loader, null) : payrollSetupError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    className: "payroll-setup-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "payroll-setup-table-thead"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "payroll-setup-table-tr"
  }, /*#__PURE__*/React.createElement("th", {
    key: "employee-name"
  }, "Employee Name"), /*#__PURE__*/React.createElement("th", {
    key: "salary-type"
  }, "Salary Type"), /*#__PURE__*/React.createElement("th", {
    key: "parameter"
  }, "Parameter"), /*#__PURE__*/React.createElement("th", {
    key: "rate"
  }, "Rate"), /*#__PURE__*/React.createElement("th", {
    key: "expected-hours"
  }, "Expected Hours"), /*#__PURE__*/React.createElement("th", {
    key: "effective-from"
  }, "Effective From"), role == "Admin" ? /*#__PURE__*/React.createElement("th", {
    key: "actions"
  }, "Actions") : null)), /*#__PURE__*/React.createElement("tbody", {
    className: "payroll-setup-table-tbody"
  }, payrollSetupData === null || payrollSetupData === void 0 ? void 0 : payrollSetupData.payrollSetupDetails.map(function (payrollData, index) {
    var user = payrollData.user,
      salaryTypeValue = payrollData.salaryType,
      salaryMetricValue = payrollData.salaryMetric,
      rate = payrollData.rate,
      capLimit = payrollData.capLimit,
      effectiveFrom = payrollData.effectiveFrom,
      billableHours = payrollData.billableHours,
      expectedWorkHoursForFullDay = payrollData.expectedWorkHoursForFullDay,
      expectedWorkHoursForHalfDay = payrollData.expectedWorkHoursForHalfDay,
      capLimitType = payrollData.capLimitType,
      payCapAmount = payrollData.payCapAmount,
      enablePayCapLimit = payrollData.enablePayCapLimit,
      workDays = payrollData.workDays;
    if (editedPayrollDetails.length) {
      var result = editedPayrollDetails.find(function (payroll) {
        return payroll.userId === user.userId;
      });
      if (result && Object.keys(result).length) {
        billableHours = result.billableHours;
        salaryTypeValue = result.salaryType;
        rate = result.hourlyRate;
        salaryMetricValue = result.preferredSalaryMetric;
        capLimit = result.dailyPayCap;
        effectiveFrom = result.effectiveFrom;
        expectedWorkHoursForFullDay = result.expectedWorkHoursForFullDay;
        expectedWorkHoursForHalfDay = result.expectedWorkHoursForHalfDay;
        capLimitType = result.capLimitType;
        payCapAmount = result.payCapAmount;
        enablePayCapLimit = result.enablePayCapLimit;
        workDays = result.workDays;
      }
    }
    var salaryTypeLabel = salaryType.find(function (type) {
      return type.value === salaryTypeValue;
    });
    var parameterLabel = salaryMetric.find(function (type) {
      return type.value === salaryMetricValue;
    });
    var rateLabel = rate ? "".concat(currencySymbol).concat(rate).concat(salaryTypeValue == "dayBased" ? "/day" : "/hr") : "-";
    var capLimitLabel = capLimit ? "".concat(currencySymbol).concat(capLimit.toLocaleString()) : "-";
    // let expectedHoursLabel = expectedHours ? `${expectedHours} hrs` : "-";

    parameterLabel = salaryMetric && parameterLabel && parameterLabel.label.includes("+") ? parameterLabel.label.replace("+", ",") : salaryMetric && parameterLabel ? parameterLabel.label : "-";
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "payroll-setup-table-display-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "payroll-setup-table-td-avator"
    }, getInitials(user.displayName)), /*#__PURE__*/React.createElement("div", {
      className: "payroll-setup-table-td-name"
    }, user.displayName))), /*#__PURE__*/React.createElement("td", null, salaryType && salaryTypeLabel ? salaryTypeLabel.value : "-"), /*#__PURE__*/React.createElement("td", null, parameterLabel), /*#__PURE__*/React.createElement("td", null, rate ? rateLabel : "-"), /*#__PURE__*/React.createElement("td", null, expectedWorkHoursForFullDay && salaryTypeLabel.value == "dayBased" ? "".concat(expectedWorkHoursForFullDay, " ").concat(Number(expectedWorkHoursForFullDay) > 1 ? "hrs" : "hr") : "-"), /*#__PURE__*/React.createElement("td", null, effectiveFrom ? moment(effectiveFrom).tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("DD MMM, YYYY") : "-"), role == "Admin" ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary payroll-setup-table-tbody-edit",
      onClick: function onClick() {
        return handleEditPayrollShow({
          user: user,
          salaryType: salaryTypeValue,
          salaryMetric: salaryMetricValue,
          rate: rate,
          capLimit: capLimit,
          effectiveFrom: effectiveFrom,
          billableHours: billableHours,
          payrollUserId: user.userId,
          expectedWorkHoursForFullDay: expectedWorkHoursForFullDay,
          expectedWorkHoursForHalfDay: expectedWorkHoursForHalfDay,
          capLimitType: capLimitType,
          payCapAmount: payCapAmount,
          enablePayCapLimit: enablePayCapLimit,
          workDays: workDays
        });
      }
    }, "Edit"), " ") : null);
  }))), !payrollSetupLoading && payrollSetupData && (payrollSetupData === null || payrollSetupData === void 0 ? void 0 : (_payrollSetupData$pay4 = payrollSetupData.payrollSetupDetails) === null || _payrollSetupData$pay4 === void 0 ? void 0 : _payrollSetupData$pay4.length) != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "monthly-aatendance-load-more-button-div monthly-attendance-scroll-sticky"
  }, !isAllLoaded ? isLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleLoadMore();
    }
  }, "Load More") : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the users")) : null)), /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-footer-text"
  }, "Workfolio\u2019s Payroll Calculator is a premium feature, currently in beta and available free for 1 month to all Pro plan users!"), /*#__PURE__*/React.createElement(EditPayrollModal, {
    editPayrollShow: editPayrollShow,
    handleEditPayrollClose: handleEditPayrollClose,
    userId: user.userId,
    organisationId: organisationId,
    momentNow: momentNow,
    userParameterCheck: userParameterCheck,
    setEditedPayrollDetails: setEditedPayrollDetails
  }));
};
var PayrollSchema = Yup.object().shape({
  salaryType: Yup.string().required("Required"),
  preferredSalaryMetric: Yup.string().required("Required"),
  hourlyRate: Yup.number().required("Required")
});
var errorMessage = function errorMessage(errors, touched, name) {
  var error = getIn(errors, name);
  var touch = getIn(touched, name);
  if (touch && error) {
    return /*#__PURE__*/React.createElement(Form.Label, {
      className: "error"
    }, error);
  }
  return null;
};
var EditPayrollModal = function EditPayrollModal(props) {
  var _editPayrollShow$user;
  var editPayrollShow = props.editPayrollShow,
    handleEditPayrollClose = props.handleEditPayrollClose,
    userId = props.userId,
    organisationId = props.organisationId,
    momentNow = props.momentNow,
    userParameterCheck = props.userParameterCheck,
    setEditedPayrollDetails = props.setEditedPayrollDetails;
  if (!editPayrollShow) {
    return null;
  }
  var _useMutation = useMutation(ADD_PAYROLL_SETUP_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    AddPayrollSetup = _useMutation2[0],
    addPayrollSetupLoading = _useMutation2[1].loading;
  var onPayrollEdit = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, actions) {
      var billableHours, dailyPayCap, effectiveFrom, expectedWorkHoursPerDay, hourlyRate, preferredSalaryMetric, salaryType, expectedWorkHoursPerHalfDay, capLimitType, payCapAmount, enablePayCapLimit, workDays, date, now, effectiveFromNowTime, variables, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            billableHours = values.billableHours, dailyPayCap = values.dailyPayCap, effectiveFrom = values.effectiveFrom, expectedWorkHoursPerDay = values.expectedWorkHoursPerDay, hourlyRate = values.hourlyRate, preferredSalaryMetric = values.preferredSalaryMetric, salaryType = values.salaryType, expectedWorkHoursPerHalfDay = values.expectedWorkHoursPerHalfDay, capLimitType = values.capLimitType, payCapAmount = values.payCapAmount, enablePayCapLimit = values.enablePayCapLimit, workDays = values.workDays;
            date = typeof effectiveFrom === "number" ? new Date(effectiveFrom) : effectiveFrom;
            now = new Date();
            effectiveFromNowTime = date.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
            variables = {
              billableHours: billableHours,
              currency: null,
              dailyPayCap: dailyPayCap,
              effectiveFrom: moment(effectiveFromNowTime).valueOf(),
              expectedWorkHoursPerDay: expectedWorkHoursPerDay,
              hourlyRate: hourlyRate,
              preferredSalaryMetric: preferredSalaryMetric,
              salaryType: salaryType,
              userId: editPayrollShow.payrollUserId,
              organisationId: organisationId,
              expectedWorkHoursPerHalfDay: expectedWorkHoursPerHalfDay,
              capLimitType: null,
              payCapAmount: 0,
              enablePayCapLimit: false,
              workDays: workDays ? workDays.join() : null
            };
            _context.prev = 5;
            _context.next = 8;
            return AddPayrollSetup({
              variables: variables
              // awaitRefetchQueries: true,
              // refetchQueries: [
              //   {
              //     query: PAYROLL_SETUP_DETAILS_QUERY,
              //     variables: {
              //       organisationId,
              //       date: momentNow,
              //       limit: LIMIT,
              //       offset: 0,
              //       userId: userParameterCheck.value,
              //     },
              //   },
              // ],
            });
          case 8:
            response = _context.sent;
            if (!(!response || !response.data || response.data.addPayrollSetup == null)) {
              _context.next = 14;
              break;
            }
            toast.success("Error Occured, try again later!");
            throw new Error("error");
          case 14:
            toast.success("Setup updated successfully!");
            setEditedPayrollDetails(function (prevItems) {
              return [].concat(_toConsumableArray(prevItems.filter(function (item) {
                return item.userId !== editPayrollShow.payrollUserId;
              })), [
              // remove old one
              {
                billableHours: billableHours,
                currency: null,
                dailyPayCap: dailyPayCap,
                effectiveFrom: effectiveFrom,
                expectedWorkHoursPerDay: expectedWorkHoursPerDay,
                hourlyRate: hourlyRate,
                preferredSalaryMetric: preferredSalaryMetric,
                salaryType: salaryType,
                userId: editPayrollShow.payrollUserId,
                expectedWorkHoursPerHalfDay: expectedWorkHoursPerHalfDay,
                capLimitType: capLimitType,
                payCapAmount: payCapAmount,
                enablePayCapLimit: enablePayCapLimit,
                workDays: workDays ? workDays.join() : null
              }]);
            });
            handleEditPayrollClose();
          case 17:
            _context.next = 21;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](5);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 19]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [AddPayrollSetup, addPayrollSetupLoading]);
  var payrollValues = {
    // employeeName: "",
    salaryType: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.salaryType ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.salaryType : "hourlyBased",
    preferredSalaryMetric: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.salaryMetric ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.salaryMetric : "workedHours",
    // currency: editPayrollShow && editPayrollShow?.currency ? editPayrollShow?.currency : "INR",
    hourlyRate: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.rate ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.rate : null,
    // billableHours: editPayrollShow && editPayrollShow?.billableHours ? editPayrollShow?.billableHours : null,
    billableHours: null,
    dailyPayCap: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.capLimit ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.capLimit : null,
    effectiveFrom: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.effectiveFrom ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.effectiveFrom : new Date(),
    expectedWorkHoursPerDay: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.expectedWorkHoursForFullDay ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.expectedWorkHoursForFullDay : null,
    expectedWorkHoursPerHalfDay: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.expectedWorkHoursForHalfDay ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.expectedWorkHoursForHalfDay : null,
    // hourlyRateLimit: editPayrollShow && editPayrollShow?.hourlyRateLimit ? editPayrollShow?.hourlyRateLimit : null,
    enablePayCapLimit: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.enablePayCapLimit ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.enablePayCapLimit : false,
    capLimitType: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.capLimitType ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.capLimitType : "",
    payCapAmount: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.payCapAmount ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.payCapAmount : "",
    workDays: editPayrollShow && editPayrollShow !== null && editPayrollShow !== void 0 && editPayrollShow.workDays ? editPayrollShow === null || editPayrollShow === void 0 ? void 0 : editPayrollShow.workDays.split(",") : ["monday"]
  };
  var formats = "h:mm a";
  var formikRef = useRef();
  var days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
  return /*#__PURE__*/React.createElement(Modal, {
    show: editPayrollShow,
    onHide: handleEditPayrollClose,
    validationSchema: PayrollSchema,
    size: "lg",
    className: "payroll-setup-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "payroll-setup-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "payroll-setup-modal-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-modal-title-header"
  }, "Edit ", editPayrollShow === null || editPayrollShow === void 0 ? void 0 : (_editPayrollShow$user = editPayrollShow.user) === null || _editPayrollShow$user === void 0 ? void 0 : _editPayrollShow$user.displayName, "'s Settings"), /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-modal-title-sub-header"
  }, "Configure payroll settings for this employee"))), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "payroll-setup-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    innerRef: formikRef,
    onSubmit: onPayrollEdit,
    initialValues: payrollValues,
    validationSchema: PayrollSchema
  }, function (_ref3) {
    var values = _ref3.values,
      errors = _ref3.errors,
      touched = _ref3.touched,
      isSubmitting = _ref3.isSubmitting,
      setFieldError = _ref3.setFieldError,
      setFieldValue = _ref3.setFieldValue;
    var salaryTypeError = errorMessage(errors, touched, "salaryType");
    var preferredSalaryMetricError = errorMessage(errors, touched, "preferredSalaryMetric");
    var hourlyRateError = errorMessage(errors, touched, "hourlyRate");
    // const hourlyRateLimitError = errorMessage(errors, touched, "hourlyRateLimit");

    // const employeeIdError = errorMessage(errors, touched, "employeeId");

    // console.log({ workDays: values?.workDays });

    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement("h4", {
      className: "text-dark"
    }), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "salaryType"
    }, function (_ref4) {
      var field = _ref4.field,
        form = _ref4.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Salary Type ", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), salaryTypeError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: salaryType.filter(function (option) {
          return field.value == option.value;
        }),
        onChange: function onChange(e) {
          return setFieldValue("salaryType", e.value);
        },
        options: salaryType
        //defaultMenuIsOpen={true}
        ,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "preferredSalaryMetric"
    }, function (_ref5) {
      var field = _ref5.field,
        form = _ref5.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Preferred Salary Metric", " ", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), preferredSalaryMetricError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: salaryMetric.filter(function (option) {
          return field.value == option.value;
        }),
        onChange: function onChange(e) {
          return setFieldValue("preferredSalaryMetric", e.value);
        },
        options: salaryMetric
        //defaultMenuIsOpen={true}
        ,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    }))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "payroll-settings-edit-label-name"
    }, values.salaryType == "hourlyBased" ? "Hourly Rate" : "Daily Rate", " ", /*#__PURE__*/React.createElement("span", {
      "class": "add-employee-modal-form-employee-label-name-required"
    }, " *")), hourlyRateError, /*#__PURE__*/React.createElement(Field, {
      as: Form.Control,
      className: "payroll-settings-edit-input",
      name: "hourlyRate",
      type: "Number",
      required: true,
      placeholder: "Enter rate",
      isInvalid: hourlyRateError != null
    }))), values.salaryType == "dayBased" ?
    /*#__PURE__*/
    // <Col xs={12} sm={6} className="mpr-sm-4">
    //   <Form.Group>
    //     <Form.Label className="payroll-settings-edit-label-name">
    //       Minimum Billable Hours{" "}
    //       {/* <span class="add-employee-modal-form-employee-label-name-required"> *</span> */}
    //     </Form.Label>
    //     <Field
    //       as={Form.Control}
    //       className="payroll-settings-edit-input"
    //       name="billableHours"
    //       type="Number"
    //       required
    //       placeholder="Enter Billable Hours"
    //       // isInvalid={emailError != null}
    //     />
    //   </Form.Group>
    // </Col>
    React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "payroll-settings-edit-label-name"
    }, "Expected Work Hours Per Day"), /*#__PURE__*/React.createElement(Field, {
      as: Form.Control,
      className: "payroll-settings-edit-input",
      name: "expectedWorkHoursPerDay",
      type: "Number",
      required: true,
      placeholder: "Enter Expected Work Hours Per Day"
    }))) : null), /*#__PURE__*/React.createElement(Form.Row, null, values.salaryType != "hourlyBased" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "payroll-settings-edit-label-name"
    }, "Expected Work Hours Per Half Day"), /*#__PURE__*/React.createElement(Field, {
      as: Form.Control,
      className: "payroll-settings-edit-input",
      name: "expectedWorkHoursPerHalfDay",
      type: "Number",
      required: true,
      placeholder: "Enter Expected Work Hours Per Half Day"
    }))) : null), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "effectiveFrom"
    }, function (_ref6) {
      var field = _ref6.field,
        form = _ref6.form,
        meta = _ref6.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Effective From"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DatePicker, {
        id: "task-due-date",
        dateFormat: "dd/MM/yyyy",
        selected: values.effectiveFrom,
        onChange: function onChange(e) {
          setFieldValue("effectiveFrom", e);
        },
        isClearable: true,
        className: "payroll-settings-edit-effective-from",
        placeholderText: "Effective From",
        autoComplete: "off"
        // open={isManualDatePickerOpen}
        // inline
      })));
    }))));
  })), /*#__PURE__*/React.createElement(Modal.Footer, {
    className: "payroll-setup-modal-footer"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "payroll-setup-modal-close-button payroll-setup-modal-footer-button",
    onClick: handleEditPayrollClose
  }, "Close"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "payroll-setup-modal-save-button payroll-setup-modal-footer-button",
    onClick: function onClick() {
      return formikRef.current.handleSubmit();
    },
    disabled: addPayrollSetupLoading
  }, addPayrollSetupLoading ? "Updating.." : "Save Changes")));
};
var CustomToggle = /*#__PURE__*/React.forwardRef(function (_ref7, ref) {
  var children = _ref7.children,
    _onClick = _ref7.onClick,
    from = _ref7.from;
  return /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-date-filter-date",
    ref: ref,
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick(e);
    }
  }, /*#__PURE__*/React.createElement(FaRegCalendar, {
    className: "payroll-summary-date-filter-user-group-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "payroll-summary-date-filter-date-text ".concat(from === "desktop" ? "payroll-summary-date-filter-date-text-desktop" : "")
  }, children), /*#__PURE__*/React.createElement(GoChevronDown, {
    className: "payroll-summary-date-filter-dropdown-icon"
  }));
});
var PayrollSummary = function PayrollSummary(props) {
  var _payrollHeaderData$pa, _payrollHeaderData$pa2, _payrollHeaderData$pa3, _payrollHeaderData$pa4, _payrollHeaderData$pa5, _payrollHeaderData$pa6, _payrollSummaryData$p4, _payrollSummaryData$p6, _payrollSummaryData$p7;
  var organisationBilling = props.organisationBilling,
    organisationSettings = props.organisationSettings,
    organisationId = props.organisationId,
    role = props.role,
    user = props.user,
    payrollKey = props.payrollKey,
    currencySymbol = props.currencySymbol,
    momentNow = props.momentNow,
    setPayrollKey = props.setPayrollKey;
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    markAsPaidModalShow = _useState18[0],
    setMarkAsPaidModalShow = _useState18[1];
  // Mirrors the PaymentModal mutation loading so row Pay buttons can be disabled
  // while a payment is in flight (prevents re-triggering another payment).
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    paymentProcessing = _useState20[0],
    setPaymentProcessing = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    timeEntriesModalShow = _useState22[0],
    setTimeEntriesModalShow = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    incompleteTimeEntriesModalShow = _useState24[0],
    setIncompleteTimeEntriesModalShow = _useState24[1];
  var _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    hoveredRowIndex = _useState26[0],
    setHoveredRowIndex = _useState26[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isAllLoaded = _React$useState2[0],
    setIsAllLoaded = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoadingMore = _React$useState4[0],
    setIsLoadingMore = _React$useState4[1];
  var handleMarkAsPaidPayrollShow = function handleMarkAsPaidPayrollShow(payrollData) {
    setMarkAsPaidModalShow(payrollData);
  };
  var handleTimeEntriesShow = function handleTimeEntriesShow(data) {
    setTimeEntriesModalShow(_objectSpread({}, data));
  };
  var handleIncompleteTimeEntriesShow = function handleIncompleteTimeEntriesShow(data) {
    setIncompleteTimeEntriesModalShow(_objectSpread({}, data));
  };
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //const [startDate, setStartDate] = React.useState(yesterDayDate);
  var buildInitialDates = function buildInitialDates() {
    var orgTimezone = organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone;

    // When a payroll cycle is configured, default to the current period for that
    // cycle (weekly / bi-weekly / semi-monthly / monthly) so the default range
    // matches — and highlights in — the PayrollPeriodPicker.
    var cyclePeriod = getCurrentPeriodDates(organisationSettings, currentTimezone);
    if (cyclePeriod) {
      return cyclePeriod;
    }

    // No cycle configured (or no matching period): default to the current month.
    return {
      startDate: startOfDayCheck(currentTimezone, orgTimezone) ? moment().tz(currentTimezone).clone().startOf("month").startOf("day").toDate() : endOfDayCheck(currentTimezone, orgTimezone) ? moment().tz(currentTimezone).clone().startOf("month").endOf("day").toDate() : moment().tz(currentTimezone).clone().startOf("month").toDate(),
      endDate: startOfDayCheck(currentTimezone, orgTimezone) ? moment().tz(currentTimezone).clone().endOf("month").startOf("day").toDate() : endOfDayCheck(currentTimezone, orgTimezone) ? moment().tz(currentTimezone).clone().endOf("month").endOf("day").toDate() : moment().tz(currentTimezone).clone().endOf("month").toDate()
    };
  };
  var _React$useState5 = React.useState(buildInitialDates),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    dates = _React$useState6[0],
    setDate = _React$useState6[1];
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var _React$useState7 = React.useState(arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    filterData = _React$useState8[0],
    setFilterData = _React$useState8[1];
  var onFilterChange = function onFilterChange(dates) {
    setDate(dates);
    setFilterData(arrayToStringOutput([dates.startDate, dates.endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone));
  };
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };

  // If a payroll cycle is configured, snap the range (and thus startUnix/endUnix)
  // to the current period. buildInitialDates covers the mount case; this effect
  // covers organisationSettings arriving after the first render. It applies once
  // so it never clobbers a period the user later picks.
  var cyclePeriodAppliedRef = React.useRef(!!(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.payrollCycle));
  React.useEffect(function () {
    if (cyclePeriodAppliedRef.current) return;
    var cyclePeriod = getCurrentPeriodDates(organisationSettings, currentTimezone);
    if (cyclePeriod) {
      cyclePeriodAppliedRef.current = true;
      onFilterChange(cyclePeriod);
    }
  }, [organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.payrollCycle, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.payrollWeekStartsOn, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone]);
  var startUnix = Number(moment(startDate).format("x"));
  var endUnix = Number(moment(endDate).format("x"));
  var _useLazyQuery5 = useLazyQuery(PAYROLL_HEADER_SUMMARY_QUERY),
    _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 2),
    getPayrollHeaderData = _useLazyQuery6[0],
    _useLazyQuery6$ = _useLazyQuery6[1],
    payrollHeaderData = _useLazyQuery6$.data,
    payrollHeaderError = _useLazyQuery6$.error,
    payrollHeaderLoading = _useLazyQuery6$.loading;
  var _useLazyQuery7 = useLazyQuery(PAYROLL_SUMMARY_QUERY),
    _useLazyQuery8 = _slicedToArray(_useLazyQuery7, 2),
    getPayrollSummaryData = _useLazyQuery8[0],
    _useLazyQuery8$ = _useLazyQuery8[1],
    payrollSummaryData = _useLazyQuery8$.data,
    payrollSummaryError = _useLazyQuery8$.error,
    payrollSummaryLoading = _useLazyQuery8$.loading,
    payrollSummaryFetchMore = _useLazyQuery8$.fetchMore;
  React.useEffect(function () {
    if (payrollKey == "PayrollSummary") {
      getPayrollHeaderData({
        variables: {
          organisationId: organisationId,
          startDate: startUnix,
          endDate: endUnix ? endUnix : startUnix,
          userRole: role,
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          date: momentNow,
          payrollCycle: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.payrollCycle
        },
        skip: !organisationId
      });
      getPayrollSummaryData({
        variables: {
          organisationId: organisationId,
          limit: LIMIT,
          offset: 0,
          startDate: startUnix,
          endDate: endUnix ? endUnix : startUnix,
          searchText: null,
          userRole: role,
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          date: momentNow,
          payrollCycle: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.payrollCycle
        },
        skip: !organisationId
      });
    }
  }, [payrollKey, startDate, endDate]);
  function getInitials() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var words = name.trim().split(/\s+/); // split by space

    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    } else if (words.length === 1 && words[0].length > 0) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return "";
  }
  React.useEffect(function () {
    var _payrollSummaryData$p, _payrollSummaryData$p2;
    if ((payrollSummaryData === null || payrollSummaryData === void 0 ? void 0 : (_payrollSummaryData$p = payrollSummaryData.payrollSummary) === null || _payrollSummaryData$p === void 0 ? void 0 : _payrollSummaryData$p.length) !== 0 && (payrollSummaryData === null || payrollSummaryData === void 0 ? void 0 : (_payrollSummaryData$p2 = payrollSummaryData.payrollSummary) === null || _payrollSummaryData$p2 === void 0 ? void 0 : _payrollSummaryData$p2.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [payrollSummaryData === null || payrollSummaryData === void 0 ? void 0 : payrollSummaryData.payrollSummary]);
  var handleLoadMore = function handleLoadMore() {
    var _payrollSummaryData$p3;
    if (payrollSummaryLoading) return;
    setIsLoadingMore(true);
    payrollSummaryFetchMore({
      variables: {
        offset: payrollSummaryData === null || payrollSummaryData === void 0 ? void 0 : (_payrollSummaryData$p3 = payrollSummaryData.payrollSummary) === null || _payrollSummaryData$p3 === void 0 ? void 0 : _payrollSummaryData$p3.length
      },
      updateQuery: function updateQuery(prev, _ref8) {
        var _fetchMoreResult$payr3, _fetchMoreResult$payr4;
        var fetchMoreResult = _ref8.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$payr3 = fetchMoreResult.payrollSummary) === null || _fetchMoreResult$payr3 === void 0 ? void 0 : _fetchMoreResult$payr3.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$payr4 = fetchMoreResult.payrollSummary) === null || _fetchMoreResult$payr4 === void 0 ? void 0 : _fetchMoreResult$payr4.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          payrollSummary: [].concat(_toConsumableArray(prev.payrollSummary), _toConsumableArray(fetchMoreResult.payrollSummary))
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  var effectiveEndUnix = endUnix && !Number.isNaN(endUnix) ? endUnix : startUnix;

  // A custom range that exactly spans a full calendar month
  // (startUnix = first day of its month, effectiveEndUnix = last day of its month).
  var isStartOfMonth = moment(startUnix).isSame(moment(startUnix).clone().startOf("month"), "day");
  var isEndOfMonth = moment(effectiveEndUnix).isSame(moment(effectiveEndUnix).clone().endOf("month"), "day");
  var isFullMonthRange = isStartOfMonth && isEndOfMonth;
  var payabaleStatus = (organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.payrollCycle) != null ? true : filterData == "Last Month" || filterData == "This Month" || isFullMonthRange ? true : false;

  // Fall back to startUnix when endUnix is missing/invalid (single date selected),
  // otherwise moment(NaN) makes the period end NaN.
  var isSameDay = moment(startUnix).isSame(moment(effectiveEndUnix), "day");

  // Resolve the payroll period range (in unix ms) to show in the message cell.
  // - Custom range: use the selected start/end as-is.
  // - Same single day, or any filter other than This/Last Month: expand to the whole month.
  // - This Month / Last Month: already a full month range, use as-is.
  var periodStartUnix;
  var periodEndUnix;
  if (filterData == "Custom") {
    periodStartUnix = startUnix;
    periodEndUnix = effectiveEndUnix;
  } else if (isSameDay || filterData != "This Month" && filterData != "Last Month") {
    periodStartUnix = Number(moment(startUnix).startOf("month").format("x"));
    periodEndUnix = Number(moment(effectiveEndUnix).endOf("month").format("x"));
  } else {
    periodStartUnix = startUnix;
    periodEndUnix = effectiveEndUnix;
  }

  // If the resolved period spans more than one month, collapse it to a
  // single month (the end date's month) so the label never shows 2 months.
  if (!moment(periodStartUnix).isSame(moment(periodEndUnix), "month")) {
    periodStartUnix = Number(moment(periodEndUnix).startOf("month").format("x"));
    periodEndUnix = Number(moment(periodEndUnix).endOf("month").format("x"));
  }

  // e.g. "Payroll period (01 Jun - 30 Jun 2026)"
  var payrollPeriodLabel = "Payroll period (".concat(moment(periodStartUnix).format("DD MMM"), " - ").concat(moment(periodEndUnix).format("DD MMM YYYY"), ")");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-help"
  }, /*#__PURE__*/React.createElement(MdInfo, {
    className: "payroll-summary-card-help-icon"
  }), "Visit", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://workfolio.tawk.help/article/introducing-payroll-calculator-workfolio",
    target: "_blank"
  }, "this article"), " ", "to learn about the Payroll Calculator."), /*#__PURE__*/React.createElement(Card, {
    className: "p-3 rounded mb-4 payroll-summary-card-filter"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center bg-light rounded-circle mr-3",
    style: {
      width: 40,
      height: 40
    }
  }, /*#__PURE__*/React.createElement(FaCalendarAlt, {
    className: "text-primary"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
    className: "mb-1 payroll-summary-card-title"
  }, "Payroll Overview"), /*#__PURE__*/React.createElement("p", {
    className: "mb-0 text-muted payroll-summary-card-title-muted",
    style: {
      fontSize: "0.9rem"
    }
  }, "Select date range and manage payroll for all employees"))), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "d-flex justify-content-end align-items-center mt-3 mt-md-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-header-filter-wrapper"
  }, !organisationSettings.payrollCycle ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    rootClose: true,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Popover, {
      className: "page-content-wrapper-menu-filter-overlay-trigger"
    }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(TimeFilter, {
      onFilterChange: onFilterChange,
      startDate: startDate,
      endDate: endDate,
      filterData: filterData,
      onClose: hideOverlay,
      organisationBilling: organisationBilling,
      organisationSettings: organisationSettings
    })))
  }, /*#__PURE__*/React.createElement("div", {
    id: "date-filter",
    className: "payroll-summary-header-filter-date"
  }, /*#__PURE__*/React.createElement(FaRegCalendarAlt, {
    className: "page-content-wrapper-menu-filter-date-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "payroll-summary-header-filter-date-text"
  }, arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)))) : /*#__PURE__*/React.createElement(PayrollPeriodPicker, {
    startDate: startDate,
    endDate: endDate,
    onFilterChange: onFilterChange,
    hideOverlay: hideOverlay,
    organisationSettings: organisationSettings
  }), /*#__PURE__*/React.createElement(ExportDetails, {
    organisationSettings: organisationSettings,
    organisationId: organisationId,
    role: role,
    user: user,
    startUnix: startUnix,
    endUnix: endUnix,
    startDate: startDate,
    endDate: endDate,
    currencySymbol: currencySymbol,
    filterData: filterData,
    payabaleStatus: payabaleStatus,
    payrollPeriodLabel: payrollPeriodLabel
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-wrapper payroll-summary-card-wrapper-payable"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-wrapper-text"
  }, "Total Payable"), /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-wrapper-value-div"
  }, payrollHeaderLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark payroll-summary-card-wrapper-text-value"
  }, payrollHeaderData !== null && payrollHeaderData !== void 0 && (_payrollHeaderData$pa = payrollHeaderData.payrollHeaderSummary) !== null && _payrollHeaderData$pa !== void 0 && _payrollHeaderData$pa.totalPayable ? "".concat(currencySymbol).concat(payrollHeaderData === null || payrollHeaderData === void 0 ? void 0 : (_payrollHeaderData$pa2 = payrollHeaderData.payrollHeaderSummary) === null || _payrollHeaderData$pa2 === void 0 ? void 0 : _payrollHeaderData$pa2.totalPayable.toLocaleString("en-IN")) : "".concat(currencySymbol, "0")), /*#__PURE__*/React.createElement(AiOutlineDollarCircle, {
    className: "payroll-summary-card-wrapper-icon"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-wrapper payroll-summary-card-wrapper-paid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-wrapper-text"
  }, "Total Paid"), /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-wrapper-value-div payroll-summary-card-wrapper-value-paid-div"
  }, payrollHeaderLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(React.Fragment, null, payabaleStatus ? /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark payroll-summary-card-wrapper-text-value"
  }, payrollHeaderData !== null && payrollHeaderData !== void 0 && (_payrollHeaderData$pa3 = payrollHeaderData.payrollHeaderSummary) !== null && _payrollHeaderData$pa3 !== void 0 && _payrollHeaderData$pa3.totalPaid ? "".concat(currencySymbol).concat(payrollHeaderData === null || payrollHeaderData === void 0 ? void 0 : (_payrollHeaderData$pa4 = payrollHeaderData.payrollHeaderSummary) === null || _payrollHeaderData$pa4 === void 0 ? void 0 : _payrollHeaderData$pa4.totalPaid.toLocaleString("en-IN")) : "".concat(currencySymbol, "0")) : /*#__PURE__*/React.createElement("h6", {
    className: "mb-0 mt-1 payroll-summary-card-wrapper-text-not-applicable"
  }, "Not Applicable for the selected period"), /*#__PURE__*/React.createElement(FaRegCheckCircle, {
    className: "payroll-summary-card-wrapper-icon"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-wrapper payroll-summary-card-wrapper-unpaid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-wrapper-text"
  }, "Total Unpaid"), /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-card-wrapper-value-div payroll-summary-card-wrapper-value-unpaid-div"
  }, payrollHeaderLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(React.Fragment, null, payabaleStatus ? /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark payroll-summary-card-wrapper-text-value"
  }, payrollHeaderData !== null && payrollHeaderData !== void 0 && (_payrollHeaderData$pa5 = payrollHeaderData.payrollHeaderSummary) !== null && _payrollHeaderData$pa5 !== void 0 && _payrollHeaderData$pa5.totalUnPaid ? "".concat(currencySymbol).concat(payrollHeaderData === null || payrollHeaderData === void 0 ? void 0 : (_payrollHeaderData$pa6 = payrollHeaderData.payrollHeaderSummary) === null || _payrollHeaderData$pa6 === void 0 ? void 0 : _payrollHeaderData$pa6.totalUnPaid.toLocaleString("en-IN")) : "".concat(currencySymbol, "0")) : /*#__PURE__*/React.createElement("h6", {
    className: "mb-0 mt-1 payroll-summary-card-wrapper-text-not-applicable"
  }, "Not Applicable for the selected period"), /*#__PURE__*/React.createElement(FaPercent, {
    className: "payroll-summary-card-wrapper-icon-percent"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-root"
  }, /*#__PURE__*/React.createElement(Card, {
    className: "p-4 mb-4 shadow-sm member-profile-payroll-details-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-header-wrapper"
  }, /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-header"
  }, "Payroll Summary"), /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-sub-title"
  }, "View and process calculated payroll for all employees"))), /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-table-div"
  }, payrollSummaryLoading ? /*#__PURE__*/React.createElement(Loader, null) : payrollSummaryError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : payrollSummaryData && (payrollSummaryData === null || payrollSummaryData === void 0 ? void 0 : payrollSummaryData.payrollSummary.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "payroll-no-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-title-1"
  }, "Payroll settings are not configured. Please complete the", " ", /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setPayrollKey("PayrollSetup");
    },
    className: "payroll-summary-title-redirection-link"
  }, "payroll setup"), " ", "to view employee salary data.")) : /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    className: "payroll-setup-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "payroll-setup-table-thead"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "payroll-setup-table-tr"
  }, /*#__PURE__*/React.createElement("th", {
    key: "employee-name"
  }, "Employee Name"), /*#__PURE__*/React.createElement("th", {
    key: "parameter"
  }, "Parameter"), /*#__PURE__*/React.createElement("th", {
    key: "rate"
  }, "Rate"), /*#__PURE__*/React.createElement("th", {
    key: "total-hours"
  }, "Billable Hours/Days"), /*#__PURE__*/React.createElement("th", {
    key: "total-hours"
  }, "Non Billable Hours"), /*#__PURE__*/React.createElement("th", {
    key: "total-earned"
  }, "Total Earned"), /*#__PURE__*/React.createElement("th", {
    key: "total-paid"
  }, "Paid"), /*#__PURE__*/React.createElement("th", {
    key: "status"
  }, "Status"))), /*#__PURE__*/React.createElement("tbody", {
    className: "payroll-setup-table-tbody"
  }, payrollSummaryData === null || payrollSummaryData === void 0 ? void 0 : (_payrollSummaryData$p4 = payrollSummaryData.payrollSummary) === null || _payrollSummaryData$p4 === void 0 ? void 0 : _payrollSummaryData$p4.map(function (payrollData, index) {
    var _payrollSummaryData$p5, _payrollHeaderData$pa7, _payrollHeaderData$pa8, _payrollHeaderData$pa9, _payrollHeaderData$pa10, _payrollHeaderData$pa11, _payrollHeaderData$pa12;
    var user = payrollData.user,
      salaryTypeValue = payrollData.salaryType,
      salaryMetricValue = payrollData.salaryMetric,
      rate = payrollData.rate,
      totalHours = payrollData.totalHours,
      totalEarned = payrollData.totalEarned,
      status = payrollData.status,
      totalDays = payrollData.totalDays,
      remainingAmount = payrollData.remainingAmount,
      paidAmount = payrollData.paidAmount,
      adjustment = payrollData.adjustment,
      incompleteDaysCount = payrollData.incompleteDaysCount,
      nonBillableHours = payrollData.nonBillableHours;
    var salaryTypeLabel = salaryType.find(function (type) {
      return type.value === salaryTypeValue;
    });
    var parameterLabel = salaryMetric.find(function (type) {
      return type.value === salaryMetricValue;
    });
    var rateLabel = rate ? "".concat(currencySymbol).concat(rate).concat(salaryTypeValue == "dayBased" ? "/day" : "/hr") : "-";
    var totalTime = salaryTypeValue == "hourlyBased" ? totalHours : salaryTypeValue == "dayBased" ? totalDays : "-";
    var totalEarnedValue = totalEarned ? "".concat(currencySymbol).concat(totalEarned.toLocaleString("en-IN")) : "".concat(currencySymbol, "0");
    var remainingAmountLabel = remainingAmount ? "".concat(currencySymbol).concat(remainingAmount.toLocaleString("en-IN")) : "".concat(currencySymbol, "0");
    var adjustmentLabel = adjustment && adjustment != "-" ? "".concat(currencySymbol).concat(adjustment.toLocaleString("en-IN")) : "".concat(currencySymbol, "0");
    parameterLabel = salaryMetric && parameterLabel && parameterLabel.label.includes("+") ? parameterLabel.label.replace("+", ",") : salaryMetric && parameterLabel ? parameterLabel.label : "-";
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
      onMouseEnter: function onMouseEnter() {
        return setHoveredRowIndex(index);
      },
      onMouseLeave: function onMouseLeave() {
        return setHoveredRowIndex(null);
      }
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "payroll-setup-table-name-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "payroll-setup-table-td-avator"
    }, getInitials(user.displayName)), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top",
        className: "project-tooltip-start"
      }, user.displayName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "payroll-setup-table-td-name"
    }, user.displayName)))), /*#__PURE__*/React.createElement("td", null, parameterLabel), /*#__PURE__*/React.createElement("td", null, rateLabel), /*#__PURE__*/React.createElement("td", {
      className: "".concat(salaryTypeValue == "hourlyBased" && totalHours == "Error" ? "payroll-data-error-status" : salaryTypeValue == "hourlyBased" && totalHours == "00:00" || salaryTypeValue == "dayBased" && totalDays == "0" ? "payroll-setup-table-td-not-available-value" : "payroll-setup-table-td-not-available-value-total-value"),
      onClick: function onClick() {
        handleTimeEntriesShow({
          user: user,
          totalHours: totalHours,
          totalDays: totalDays,
          salaryType: salaryTypeValue
        });
      }
    }, totalHours == "Error" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top-start",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Error in hour, Please Contact support")
    }, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, totalTime)) : totalTime), /*#__PURE__*/React.createElement("td", {
      className: "".concat(salaryTypeValue == "hourlyBased" ? "payroll-setup-table-td-not-available-value" : "payroll-setup-table-td-incomplete-day"),
      onClick: function onClick() {
        if (salaryTypeValue != "hourlyBased") {
          handleIncompleteTimeEntriesShow({
            user: user,
            totalHours: totalHours,
            totalDays: totalDays,
            salaryType: salaryTypeValue,
            nonBillableHours: nonBillableHours
          });
        }
      }
    }, salaryTypeValue == "hourlyBased" ? "Not Applicable" : nonBillableHours), /*#__PURE__*/React.createElement("td", {
      className: "".concat(totalEarned == 0 ? "payroll-setup-table-td-not-available-value" : "")
    }, totalEarnedValue.toLocaleString("en-IN")), payabaleStatus ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
      className: "".concat(totalEarned == 0 ? "payroll-setup-table-td-not-available-value" : "")
    }, currencySymbol, "  ", paidAmount.toLocaleString("en-IN")), /*#__PURE__*/React.createElement("td", null, status == "Error" ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(status == "Error" ? "payroll-data-error-status" : "")
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top-start",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Error in hour, Please Contact support")
    }, /*#__PURE__*/React.createElement("span", null, "Error"))) : status != "Paid" && status != "-" ? /*#__PURE__*/React.createElement("div", {
      className: "payroll-setup-table-td-status"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outline-primary payroll-setup-table-tbody-mark-paid",
      disabled: paymentProcessing,
      onClick: function onClick() {
        handleMarkAsPaidPayrollShow({
          payrollSummary: [_objectSpread({}, payrollData)],
          type: "markAsPaid"
        });
      }
    }, "Pay ", remainingAmountLabel, " ", hoveredRowIndex == index ? /*#__PURE__*/React.createElement(MdArrowForward, null) : null)) : status == "Paid" ? /*#__PURE__*/React.createElement("div", {
      className: "payroll-setup-table-td-status-paid"
    }, /*#__PURE__*/React.createElement("span", {
      className: "payroll-setup-table-td-icon-sapn"
    }, /*#__PURE__*/React.createElement(FaCheckCircle, {
      className: "payroll-setup-table-td-icon"
    })), " ", /*#__PURE__*/React.createElement("span", null, status)) : /*#__PURE__*/React.createElement("div", {
      className: "".concat(status == "-" ? "payroll-setup-table-td-not-available-value" : "")
    }, /*#__PURE__*/React.createElement("span", null, "-")))) : /*#__PURE__*/React.createElement("td", {
      colSpan: 2,
      className: "".concat(totalEarned == 0 ? "payroll-setup-table-td-not-available-value" : "")
    }, payrollPeriodLabel, ": ", currencySymbol, "  ", paidAmount.toLocaleString("en-IN"), " paid.")), index === (payrollSummaryData === null || payrollSummaryData === void 0 ? void 0 : (_payrollSummaryData$p5 = payrollSummaryData.payrollSummary) === null || _payrollSummaryData$p5 === void 0 ? void 0 : _payrollSummaryData$p5.length) - 1 && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, "Total"), /*#__PURE__*/React.createElement("td", null, payrollHeaderData !== null && payrollHeaderData !== void 0 && (_payrollHeaderData$pa7 = payrollHeaderData.payrollHeaderSummary) !== null && _payrollHeaderData$pa7 !== void 0 && _payrollHeaderData$pa7.totalPayable ? "".concat(currencySymbol).concat(payrollHeaderData === null || payrollHeaderData === void 0 ? void 0 : (_payrollHeaderData$pa8 = payrollHeaderData.payrollHeaderSummary) === null || _payrollHeaderData$pa8 === void 0 ? void 0 : _payrollHeaderData$pa8.totalPayable.toLocaleString("en-IN")) : "".concat(currencySymbol, "0")), payabaleStatus ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, payrollHeaderData !== null && payrollHeaderData !== void 0 && (_payrollHeaderData$pa9 = payrollHeaderData.payrollHeaderSummary) !== null && _payrollHeaderData$pa9 !== void 0 && _payrollHeaderData$pa9.totalPaid ? "".concat(currencySymbol).concat(payrollHeaderData === null || payrollHeaderData === void 0 ? void 0 : (_payrollHeaderData$pa10 = payrollHeaderData.payrollHeaderSummary) === null || _payrollHeaderData$pa10 === void 0 ? void 0 : _payrollHeaderData$pa10.totalPaid.toLocaleString("en-IN")) : "".concat(currencySymbol, "0")), /*#__PURE__*/React.createElement("td", null, payrollHeaderData !== null && payrollHeaderData !== void 0 && (_payrollHeaderData$pa11 = payrollHeaderData.payrollHeaderSummary) !== null && _payrollHeaderData$pa11 !== void 0 && _payrollHeaderData$pa11.totalUnPaid ? "".concat(currencySymbol).concat(payrollHeaderData === null || payrollHeaderData === void 0 ? void 0 : (_payrollHeaderData$pa12 = payrollHeaderData.payrollHeaderSummary) === null || _payrollHeaderData$pa12 === void 0 ? void 0 : _payrollHeaderData$pa12.totalUnPaid.toLocaleString("en-IN")) : "".concat(currencySymbol, "0"))) : /*#__PURE__*/React.createElement("td", {
      colSpan: 2
    }, " ")));
  }))), !payrollSummaryLoading && payrollSummaryData && (payrollSummaryData === null || payrollSummaryData === void 0 ? void 0 : (_payrollSummaryData$p6 = payrollSummaryData.payrollSummary) === null || _payrollSummaryData$p6 === void 0 ? void 0 : _payrollSummaryData$p6.length) != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "monthly-aatendance-load-more-button-div monthly-attendance-scroll-sticky"
  }, !isAllLoaded ? isLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleLoadMore();
    }
  }, "Load More") : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the users")) : null), /*#__PURE__*/React.createElement(Card.Footer, {
    className: "text-muted text-end px-0 pt-3",
    style: {
      marginLeft: "-1.5rem",
      marginRight: "-1.5rem",
      marginBottom: "-1.5rem"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-footer-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-footer-date-range"
  }, /*#__PURE__*/React.createElement(FaRegCalendar, {
    className: "payroll-summary-footer-date-icon"
  }), "Date Range:", " ", /*#__PURE__*/React.createElement("span", {
    className: "payroll-summary-footer-date-text"
  }, endDate == null ? moment(startDate).format("DD-MM-yyyy") : " ".concat(moment(startDate).format("DD-MM-yyyy"), " to ").concat(moment(endDate).format("DD-MM-yyyy")))), /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-footer-users"
  }, /*#__PURE__*/React.createElement(FaUser, {
    className: "payroll-summary-footer-date-icon"
  }), "Showing ", payrollSummaryData === null || payrollSummaryData === void 0 ? void 0 : (_payrollSummaryData$p7 = payrollSummaryData.payrollSummary) === null || _payrollSummaryData$p7 === void 0 ? void 0 : _payrollSummaryData$p7.length, " Employees")))), /*#__PURE__*/React.createElement(PaymentModal, {
    show: markAsPaidModalShow,
    onHide: function onHide() {
      return setMarkAsPaidModalShow(false);
    },
    organisationId: organisationId,
    currentUser: user,
    startDate: startUnix,
    endDate: endUnix,
    role: role,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    currencySymbol: currencySymbol,
    momentNow: momentNow,
    onProcessingChange: setPaymentProcessing
  }), /*#__PURE__*/React.createElement(TimeEntriesModal, {
    show: timeEntriesModalShow,
    onHide: function onHide() {
      return setTimeEntriesModalShow(false);
    },
    organisationId: organisationId,
    currentUser: user,
    startDate: startDate,
    endDate: endDate,
    role: role,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    currencySymbol: currencySymbol,
    momentNow: momentNow
  }), /*#__PURE__*/React.createElement(IncmpleteTimeEntriesModal, {
    show: incompleteTimeEntriesModalShow,
    onHide: function onHide() {
      return setIncompleteTimeEntriesModalShow(false);
    },
    organisationId: organisationId,
    currentUser: user,
    startDate: startDate,
    endDate: endDate,
    role: role,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    currencySymbol: currencySymbol,
    momentNow: momentNow
  })), /*#__PURE__*/React.createElement("div", {
    className: "payroll-setup-footer-text"
  }, "Workfolio\u2019s Payroll Calculator is a premium feature, currently in beta and available free for 1 month to all Pro plan users!"));
};
var TimeEntriesModal = function TimeEntriesModal(_ref9) {
  var _memberTimeEntriesDat5, _memberTimeEntriesDat6, _memberTimeEntriesDat7, _memberTimeEntriesDat10, _memberTimeEntriesDat11;
  var show = _ref9.show,
    onHide = _ref9.onHide,
    organisationId = _ref9.organisationId,
    currentUser = _ref9.currentUser,
    startDate = _ref9.startDate,
    endDate = _ref9.endDate,
    role = _ref9.role,
    timezone = _ref9.timezone,
    currencySymbol = _ref9.currencySymbol,
    momentNow = _ref9.momentNow;
  if (!show) {
    return null;
  }
  var user = show.user,
    totalHours = show.totalHours,
    totalDays = show.totalDays,
    salaryType = show.salaryType;
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isAllLoaded = _React$useState10[0],
    setIsAllLoaded = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isLoadingMore = _React$useState12[0],
    setIsLoadingMore = _React$useState12[1];
  var _useLazyQuery9 = useLazyQuery(MEMBER_TIME_ENTRIES_FOR_SUMMARY_QUERY),
    _useLazyQuery10 = _slicedToArray(_useLazyQuery9, 2),
    getMemberTimeEntriesData = _useLazyQuery10[0],
    _useLazyQuery10$ = _useLazyQuery10[1],
    memberTimeEntriesData = _useLazyQuery10$.data,
    memberTimeEntriesError = _useLazyQuery10$.error,
    memberTimeEntriesLoading = _useLazyQuery10$.loading,
    memberTimeEntriesFetchMore = _useLazyQuery10$.fetchMore;
  React.useEffect(function () {
    if (show) {
      getMemberTimeEntriesData({
        variables: {
          organisationId: organisationId,
          startDate: startDate,
          endDate: endDate,
          timezone: timezone,
          userId: user ? user.userId : null,
          limit: LIMIT,
          offset: 0,
          date: moment(),
          dayType: salaryType != "hourlyBased" ? "billableDays" : "all"
        },
        skip: !organisationId && !user
      });
    }
  }, [show]);
  React.useEffect(function () {
    var _memberTimeEntriesDat, _memberTimeEntriesDat2, _memberTimeEntriesDat3, _memberTimeEntriesDat4;
    if ((memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat === void 0 ? void 0 : (_memberTimeEntriesDat2 = _memberTimeEntriesDat.timeEnties) === null || _memberTimeEntriesDat2 === void 0 ? void 0 : _memberTimeEntriesDat2.length) !== 0 && (memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat3 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat3 === void 0 ? void 0 : (_memberTimeEntriesDat4 = _memberTimeEntriesDat3.timeEnties) === null || _memberTimeEntriesDat4 === void 0 ? void 0 : _memberTimeEntriesDat4.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat5 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat5 === void 0 ? void 0 : _memberTimeEntriesDat5.timeEnties]);

  // const handleLoadMore = () => {
  //   if (memberTimeEntriesLoading) return;

  //   setIsLoadingMore(true);

  //   memberTimeEntriesFetchMore({
  //     variables: {
  //       offset: memberTimeEntriesData?.memberTimeEntriesForSummary?.length,
  //     },

  //     updateQuery: (prev, { fetchMoreResult }) => {
  //       if (!fetchMoreResult) return prev;

  //       if (
  //         fetchMoreResult?.memberTimeEntriesForSummary?.length === 0 &&
  //         fetchMoreResult?.memberTimeEntriesForSummary?.length < LIMIT &&
  //         !isAllLoaded
  //       ) {
  //         setIsAllLoaded(true);
  //       }
  //       //setIsLoadMoreButton(false);
  //       setIsLoadingMore(false);
  //       return {
  //         ...prev,
  //         memberTimeEntriesForSummary: [
  //           ...prev.memberTimeEntriesForSummary,
  //           ...fetchMoreResult.memberTimeEntriesForSummary,
  //         ],
  //       };
  //     },
  //   });
  //   //setLoadMoreButtonLoading(false);
  // };

  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: onHide,
    size: "lg",
    centered: true,
    className: "payroll-summary-payment-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "payroll-summary-payment-modal-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "payroll-summary-payment-modal-title"
  }, user.displayName, "'s Time Entries")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "text-center payroll-summary-payment-modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-responsive member-profile-time-entries-table-payroll-div"
  }, memberTimeEntriesLoading ? /*#__PURE__*/React.createElement(Loader, null) : memberTimeEntriesError ? "Error" : (memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat6 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat6 === void 0 ? void 0 : _memberTimeEntriesDat6.timeEnties.length) == 0 ? "No data" : /*#__PURE__*/React.createElement(Table, {
    hover: true,
    className: "member-profile-time-entries-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "member-profile-time-entries-thead"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "member-profile-time-entries-table-tr"
  }, /*#__PURE__*/React.createElement("th", null, "Date"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", null, "Clock In"), /*#__PURE__*/React.createElement("th", null, "Clock Out"), /*#__PURE__*/React.createElement("th", null, "Total Worked Hours"), salaryType != "hourlyBased" ? /*#__PURE__*/React.createElement("th", null, "Billable Days") : null)), /*#__PURE__*/React.createElement("tbody", {
    className: "member-profile-time-entries-tbody"
  }, memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat7 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat7 === void 0 ? void 0 : _memberTimeEntriesDat7.timeEnties.map(function (entry, index) {
    var _memberTimeEntriesDat8, _memberTimeEntriesDat9;
    var workedDay = entry.workedDay,
      workedSec = entry.workedSec,
      untrackedSec = entry.untrackedSec,
      clockIn = entry.clockIn,
      clockOut = entry.clockOut,
      dayType = entry.dayType;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
      key: index,
      className: "member-profile-time-entries-table-tbody-tr"
    }, /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-date"
    }, workedDay), /*#__PURE__*/React.createElement("td", {
      className: "text-success member-profile-time-entries-table-tbody-tr-status"
    }, /*#__PURE__*/React.createElement(FaRegCheckCircle, {
      className: "mr-2 member-profile-time-entries-table-tbody-tr-status-icon"
    }), "Present"), /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-time"
    }, clockIn), /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-time"
    }, clockOut), /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-hours"
    }, /*#__PURE__*/React.createElement(FaRegClock, {
      className: "mr-2 text-muted member-profile-time-entries-table-tbody-tr-hours-icon"
    }), workedSec), salaryType != "hourlyBased" ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Badge, {
      pill: true,
      variant: dayType == "Full Day" ? "success member-profile-time-entries-table-tbody-tr-full-day" : dayType == "Half Day" ? "primary member-profile-time-entries-table-tbody-tr-half-day" : "warning member-profile-time-entries-table-tbody-tr-insufficient-hours"
    }, dayType), " ") : null), index == (memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat8 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat8 === void 0 ? void 0 : _memberTimeEntriesDat8.timeEnties.length) - 1 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), salaryType == "hourlyBased" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, "Total:"), /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-hours"
    }, " ", /*#__PURE__*/React.createElement(FaRegClock, {
      className: "mr-2 text-muted member-profile-time-entries-table-tbody-tr-hours-icon"
    }), memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat9 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat9 === void 0 ? void 0 : _memberTimeEntriesDat9.totalWorkedHours)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, "Total:"), /*#__PURE__*/React.createElement("td", null, totalDays))) : null);
  }))), !memberTimeEntriesLoading && memberTimeEntriesData && (memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat10 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat10 === void 0 ? void 0 : (_memberTimeEntriesDat11 = _memberTimeEntriesDat10.timeEnties) === null || _memberTimeEntriesDat11 === void 0 ? void 0 : _memberTimeEntriesDat11.length) != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "monthly-aatendance-load-more-button-div monthly-attendance-scroll-sticky"
  }, !isAllLoaded ? isLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : null :
  /*#__PURE__*/
  // <Button variant="primary" onClick={() => handleLoadMore()}>
  //   Load More
  // </Button>
  React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the datas")) : null))));
};
var IncmpleteTimeEntriesModal = function IncmpleteTimeEntriesModal(_ref10) {
  var _memberTimeEntriesDat16, _memberTimeEntriesDat17, _memberTimeEntriesDat18, _memberTimeEntriesDat19, _memberTimeEntriesDat23, _memberTimeEntriesDat24;
  var show = _ref10.show,
    onHide = _ref10.onHide,
    organisationId = _ref10.organisationId,
    currentUser = _ref10.currentUser,
    startDate = _ref10.startDate,
    endDate = _ref10.endDate,
    role = _ref10.role,
    timezone = _ref10.timezone,
    currencySymbol = _ref10.currencySymbol,
    momentNow = _ref10.momentNow;
  if (!show) {
    return null;
  }
  var user = show.user,
    totalHours = show.totalHours,
    totalDays = show.totalDays,
    salaryType = show.salaryType;
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isAllLoaded = _React$useState14[0],
    setIsAllLoaded = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isLoadingMore = _React$useState16[0],
    setIsLoadingMore = _React$useState16[1];
  var _useLazyQuery11 = useLazyQuery(MEMBER_TIME_ENTRIES_FOR_SUMMARY_QUERY),
    _useLazyQuery12 = _slicedToArray(_useLazyQuery11, 2),
    getMemberTimeEntriesData = _useLazyQuery12[0],
    _useLazyQuery12$ = _useLazyQuery12[1],
    memberTimeEntriesData = _useLazyQuery12$.data,
    memberTimeEntriesError = _useLazyQuery12$.error,
    memberTimeEntriesLoading = _useLazyQuery12$.loading,
    memberTimeEntriesFetchMore = _useLazyQuery12$.fetchMore;
  React.useEffect(function () {
    if (show) {
      getMemberTimeEntriesData({
        variables: {
          organisationId: organisationId,
          startDate: startDate,
          endDate: endDate,
          timezone: timezone,
          userId: user ? user.userId : null,
          limit: LIMIT,
          offset: 0,
          date: moment(),
          dayType: "nonBillableDays"
        },
        skip: !organisationId && !user
      });
    }
  }, [show]);
  React.useEffect(function () {
    var _memberTimeEntriesDat12, _memberTimeEntriesDat13, _memberTimeEntriesDat14, _memberTimeEntriesDat15;
    if ((memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat12 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat12 === void 0 ? void 0 : (_memberTimeEntriesDat13 = _memberTimeEntriesDat12.timeEnties) === null || _memberTimeEntriesDat13 === void 0 ? void 0 : _memberTimeEntriesDat13.length) !== 0 && (memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat14 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat14 === void 0 ? void 0 : (_memberTimeEntriesDat15 = _memberTimeEntriesDat14.timeEnties) === null || _memberTimeEntriesDat15 === void 0 ? void 0 : _memberTimeEntriesDat15.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat16 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat16 === void 0 ? void 0 : _memberTimeEntriesDat16.timeEnties]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: onHide,
    size: "lg",
    centered: true,
    className: "payroll-summary-payment-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "payroll-summary-payment-modal-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "payroll-summary-payment-modal-title"
  }, user.displayName, "'s Time Entries")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "text-center payroll-summary-payment-modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-responsive member-profile-time-entries-table-payroll-div"
  }, memberTimeEntriesLoading ? /*#__PURE__*/React.createElement(Loader, null) : memberTimeEntriesError ? "Error" : (memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat17 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat17 === void 0 ? void 0 : (_memberTimeEntriesDat18 = _memberTimeEntriesDat17.timeEnties) === null || _memberTimeEntriesDat18 === void 0 ? void 0 : _memberTimeEntriesDat18.length) == 0 ? "No data" : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: "member-profile-time-entries-table-payroll-notes-div"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "member-profile-time-entries-table-payroll-notes-title"
  }, "Billable & Non Billable Hours Logic"), /*#__PURE__*/React.createElement("ul", {
    className: "member-profile-time-entries-table-payroll-notes-text"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "< Half Day"), ": Non-billable"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "Half to Full Day"), ": Only Half Day hours billable"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "> Full Day"), ": Only Full Day hours billable")), /*#__PURE__*/React.createElement("p", {
    className: "member-profile-time-entries-table-payroll-notes-p-tag"
  }, "Extra hours beyond thresholds are non-billable.")), /*#__PURE__*/React.createElement(Table, {
    hover: true,
    className: "member-profile-time-entries-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "member-profile-time-entries-thead"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "member-profile-time-entries-table-tr"
  }, /*#__PURE__*/React.createElement("th", null, "Date"), /*#__PURE__*/React.createElement("th", null, "Clock In"), /*#__PURE__*/React.createElement("th", null, "Clock Out"), /*#__PURE__*/React.createElement("th", null, "Total Worked Hours"), /*#__PURE__*/React.createElement("th", null, "Billable Hours"), /*#__PURE__*/React.createElement("th", null, "Non Billable Hours"))), /*#__PURE__*/React.createElement("tbody", {
    className: "member-profile-time-entries-tbody"
  }, memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat19 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat19 === void 0 ? void 0 : _memberTimeEntriesDat19.timeEnties.map(function (entry, index) {
    var _memberTimeEntriesDat20, _memberTimeEntriesDat21, _memberTimeEntriesDat22;
    var workedDay = entry.workedDay,
      workedSec = entry.workedSec,
      untrackedSec = entry.untrackedSec,
      clockIn = entry.clockIn,
      clockOut = entry.clockOut,
      dayType = entry.dayType,
      billableHours = entry.billableHours,
      nonBillableHours = entry.nonBillableHours;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
      key: index,
      className: "member-profile-time-entries-table-tbody-tr"
    }, /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-date"
    }, workedDay), /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-time"
    }, clockIn), /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-time"
    }, clockOut), /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-hours"
    }, /*#__PURE__*/React.createElement(FaRegClock, {
      className: "mr-2 text-muted member-profile-time-entries-table-tbody-tr-hours-icon"
    }), workedSec), /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-hours"
    }, /*#__PURE__*/React.createElement(FaRegClock, {
      className: "mr-2 text-muted member-profile-time-entries-table-tbody-tr-hours-icon"
    }), billableHours), /*#__PURE__*/React.createElement("td", {
      className: "member-profile-time-entries-table-tbody-tr-hours"
    }, /*#__PURE__*/React.createElement(FaRegClock, {
      className: "mr-2 text-muted member-profile-time-entries-table-tbody-tr-hours-icon"
    }), nonBillableHours)), index == (memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat20 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat20 === void 0 ? void 0 : (_memberTimeEntriesDat21 = _memberTimeEntriesDat20.timeEnties) === null || _memberTimeEntriesDat21 === void 0 ? void 0 : _memberTimeEntriesDat21.length) - 1 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, "Total:"), /*#__PURE__*/React.createElement("td", null, memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat22 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat22 === void 0 ? void 0 : _memberTimeEntriesDat22.totalNonBillableHours)) : null);
  })))), !memberTimeEntriesLoading && memberTimeEntriesData && (memberTimeEntriesData === null || memberTimeEntriesData === void 0 ? void 0 : (_memberTimeEntriesDat23 = memberTimeEntriesData.memberTimeEntriesForSummary) === null || _memberTimeEntriesDat23 === void 0 ? void 0 : (_memberTimeEntriesDat24 = _memberTimeEntriesDat23.timeEnties) === null || _memberTimeEntriesDat24 === void 0 ? void 0 : _memberTimeEntriesDat24.length) != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "monthly-aatendance-load-more-button-div monthly-attendance-scroll-sticky"
  }, !isAllLoaded ? isLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : null :
  /*#__PURE__*/
  // <Button variant="primary" onClick={() => handleLoadMore()}>
  //   Load More
  // </Button>
  React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the datas")) : null))));
};
var PaymentModal = function PaymentModal(_ref11) {
  var show = _ref11.show,
    onHide = _ref11.onHide,
    organisationId = _ref11.organisationId,
    currentUser = _ref11.currentUser,
    startDate = _ref11.startDate,
    endDate = _ref11.endDate,
    role = _ref11.role,
    timezone = _ref11.timezone,
    currencySymbol = _ref11.currencySymbol,
    momentNow = _ref11.momentNow,
    onProcessingChange = _ref11.onProcessingChange;
  var client = useApolloClient();
  var _ref12 = show || {},
    type = _ref12.type,
    payrollSummary = _ref12.payrollSummary;
  var _ref13 = payrollSummary && payrollSummary[0] || {},
    user = _ref13.user,
    totalEarned = _ref13.totalEarned,
    totalHours = _ref13.totalHours,
    remainingAmount = _ref13.remainingAmount;
  var _useState27 = useState("full-payment"),
    _useState28 = _slicedToArray(_useState27, 2),
    paymentTypeSelect = _useState28[0],
    setPaymentTypeSelect = _useState28[1];
  var _useState29 = useState(),
    _useState30 = _slicedToArray(_useState29, 2),
    partialAmount = _useState30[0],
    setPartialAmount = _useState30[1];
  var _useState31 = useState(""),
    _useState32 = _slicedToArray(_useState31, 2),
    paymentNote = _useState32[0],
    setPaymentNote = _useState32[1];
  var _useState33 = useState(""),
    _useState34 = _slicedToArray(_useState33, 2),
    partialAmountError = _useState34[0],
    setPartialAmountError = _useState34[1];
  var _useMutation3 = useMutation(PAYMENT_MARK_AS_PAID_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    PaymentMarkAsPaid = _useMutation4[0],
    paymentLoading = _useMutation4[1].loading;

  // Surface the mutation loading to the parent so row Pay buttons can disable.
  React.useEffect(function () {
    onProcessingChange === null || onProcessingChange === void 0 ? void 0 : onProcessingChange(paymentLoading);
  }, [paymentLoading, onProcessingChange]);

  // Synchronous lock: `paymentLoading` updates async, so two fast clicks can both
  // pass the check before a re-render disables the button. A ref blocks instantly.
  var isPayingRef = React.useRef(false);
  var payableAmount = (remainingAmount != 0 ? remainingAmount : totalEarned) || 0;
  var handlePartialAmountChange = function handlePartialAmountChange(e) {
    var value = e.target.value;

    // Restrict negative values
    if (value < 0) {
      value = 0;
    }
    setPartialAmount(value);
    if (!value || Number(value) === 0) {
      setPartialAmountError("Amount cannot be zero.");
    } else if (Number(value) > payableAmount) {
      setPartialAmountError("Amount cannot exceed \u20B9".concat(payableAmount.toLocaleString("en-IN"), "."));
    } else {
      setPartialAmountError("");
    }
  };
  var paymentOnSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var variables, response, paidNow;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(paymentLoading || isPayingRef.current)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", null);
        case 2:
          isPayingRef.current = true;
          variables = {
            paymentTypeSelect: paymentTypeSelect,
            amount: paymentTypeSelect == "full-payment" ? Number(payableAmount) : Number(partialAmount),
            paymentNote: paymentNote,
            organisationId: organisationId,
            paymentBy: currentUser.userId,
            paymentTo: user.userId,
            totalHours: parseFloat(totalHours),
            currency: currencySymbol,
            startDate: startDate / 1000,
            endDate: endDate / 1000,
            timezone: timezone
          };
          _context2.prev = 4;
          _context2.next = 7;
          return PaymentMarkAsPaid({
            variables: variables
          });
        case 7:
          response = _context2.sent;
          if (!(!response || !response.data || response.data.paymentMarkAsPaid == null)) {
            _context2.next = 13;
            break;
          }
          toast.error("Error Occured, try again later!");
          throw new Error("error");
        case 13:
          toast.success("payment processed for  ".concat(user.displayName));

          // Update the cache in place instead of refetching. PayrollSummary /
          // PayrollHeaderSummary aren't normalized (no id), so they're stored inline
          // under ROOT_QUERY — modify those root fields across all cached variations.
          paidNow = paymentTypeSelect == "full-payment" ? Number(payableAmount) : Number(partialAmount);
          client.cache.modify({
            fields: {
              payrollSummary: function payrollSummary(existing) {
                if (!Array.isArray(existing)) return existing;
                return existing.map(function (entry) {
                  var _entry$user;
                  if ((entry === null || entry === void 0 ? void 0 : (_entry$user = entry.user) === null || _entry$user === void 0 ? void 0 : _entry$user.userId) !== user.userId) return entry;
                  var prevPaid = Number(entry.paidAmount) || 0;
                  var prevRemaining = Number(entry.remainingAmount) || 0;
                  var newRemaining = Math.max(prevRemaining - paidNow, 0);
                  return _objectSpread(_objectSpread({}, entry), {}, {
                    paidAmount: prevPaid + paidNow,
                    remainingAmount: newRemaining,
                    status: newRemaining <= 0 ? "Paid" : entry.status
                  });
                });
              },
              payrollHeaderSummary: function payrollHeaderSummary(existing) {
                if (!existing) return existing;
                var prevPaid = Number(existing.totalPaid) || 0;
                var prevUnpaid = Number(existing.totalUnPaid) || 0;
                return _objectSpread(_objectSpread({}, existing), {}, {
                  totalPaid: prevPaid + paidNow,
                  totalUnPaid: Math.max(prevUnpaid - paidNow, 0)
                });
              }
            }
          });
          onHide();
          setPartialAmount(0);
          setPaymentNote("");
          setPaymentTypeSelect("full-payment");
        case 20:
          _context2.next = 25;
          break;
        case 22:
          _context2.prev = 22;
          _context2.t0 = _context2["catch"](4);
          toast.error("Error Occured, try again later!");
        case 25:
          _context2.prev = 25;
          isPayingRef.current = false;
          return _context2.finish(25);
        case 28:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 22, 25, 28]]);
  })), [PaymentMarkAsPaid, paymentLoading, paymentTypeSelect, partialAmount, client, organisationId, currentUser, user, totalHours, currencySymbol, startDate, endDate, role, timezone, momentNow, payableAmount, paymentNote]);
  if (!show) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: onHide,
    centered: true,
    className: "payroll-summary-payment-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-end p-2 payroll-summary-payment-modal-close"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "close",
    "aria-label": "Close",
    onClick: onHide
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"))), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "text-center payroll-summary-payment-modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-circle bg-light mx-auto mb-3",
    style: {
      width: 60,
      height: 60
    }
  }, /*#__PURE__*/React.createElement(FiDollarSign, {
    className: "payroll-summary-payment-modal-body-doller-icon",
    style: {
      lineHeight: "60px"
    }
  })), /*#__PURE__*/React.createElement("h5", {
    className: "font-weight-bold"
  }, type == "markAsPaid" ? "Payment for ".concat(user.displayName) : "Process Bulk Payment"), /*#__PURE__*/React.createElement("p", {
    className: "text-muted payroll-summary-payment-modal-body-text-2"
  }, type == "markAsPaid" ? "Process payment for this employee" : "Complete payment for all employees in the current period"), /*#__PURE__*/React.createElement("p", {
    className: "text-muted payroll-summary-payment-modal-body-text-3"
  }, "Total Payable"), /*#__PURE__*/React.createElement("h4", {
    className: "text-primary font-weight-bold"
  }, currencySymbol, payableAmount.toLocaleString("en-IN"))), /*#__PURE__*/React.createElement(Form, {
    className: "text-left"
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement("div", {
    className: "border rounded p-3 mb-2 bg-light payroll-summary-payment-modal-body-full-payment payroll-summary-payment-modal-body-payment-type ".concat(paymentTypeSelect == "full-payment" ? "payroll-summary-payment-modal-body-payment-select" : null),
    onClick: function onClick() {
      return setPaymentTypeSelect("full-payment");
    }
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "radio",
    id: "fullPayment",
    name: "paymentOption",
    label: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "payroll-summary-payment-modal-body-full-payment-text-1"
    }, /*#__PURE__*/React.createElement("strong", null, "Full Payment")), /*#__PURE__*/React.createElement("div", {
      className: "payroll-summary-payment-modal-body-full-payment-text-2"
    }, /*#__PURE__*/React.createElement("small", {
      className: "text-muted"
    }, "Pay the entire amount at once"))),
    checked: paymentTypeSelect == "full-payment",
    onChange: function onChange() {
      return setPaymentTypeSelect("full-payment");
    }
  }), paymentTypeSelect == "full-payment" ? /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-payment-modal-body-full-payment-icon-wrapper"
  }, /*#__PURE__*/React.createElement(FaCheckCircle, {
    className: "payroll-summary-payment-modal-body-full-payment-icon"
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "border rounded p-3 mb-3 bg-light payroll-summary-payment-modal-body-payment-type ".concat(paymentTypeSelect == "partial-payment" ? "payroll-summary-payment-modal-body-payment-select" : null),
    onClick: function onClick() {
      return setPaymentTypeSelect("partial-payment");
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-payment-modal-body-full-payment "
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "radio",
    id: "partialPayment",
    name: "paymentOption",
    label: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "payroll-summary-payment-modal-body-full-payment-text-1"
    }, " ", /*#__PURE__*/React.createElement("strong", null, "Partial Payment")), /*#__PURE__*/React.createElement("div", {
      className: "payroll-summary-payment-modal-body-full-payment-text-2"
    }, " ", /*#__PURE__*/React.createElement("small", {
      className: "text-muted"
    }, "Pay a portion of the total amount"))),
    checked: paymentTypeSelect == "partial-payment",
    onChange: function onChange() {
      return setPaymentTypeSelect("partial-payment");
    }
  }), paymentTypeSelect == "partial-payment" ? /*#__PURE__*/React.createElement("div", {
    className: "payroll-summary-payment-modal-body-full-payment-icon-wrapper"
  }, /*#__PURE__*/React.createElement(FaCheckCircle, {
    className: "payroll-summary-payment-modal-body-full-payment-icon"
  })) : null), paymentTypeSelect === "partial-payment" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputGroup, {
    className: "mt-3 payroll-summary-payment-modal-body-partial-payment-input-group"
  }, /*#__PURE__*/React.createElement(InputGroup.Prepend, null, /*#__PURE__*/React.createElement(InputGroup.Text, null, currencySymbol)), /*#__PURE__*/React.createElement(Form.Control, {
    type: "number",
    min: "0",
    placeholder: "Enter amount",
    value: partialAmount,
    onChange: handlePartialAmountChange,
    className: "payroll-summary-payment-modal-body-partial-payment-input ".concat(partialAmountError ? "is-invalid" : "")
  })), partialAmountError && /*#__PURE__*/React.createElement("div", {
    className: "text-danger mt-1",
    style: {
      fontSize: "0.875rem"
    }
  }, partialAmountError)))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
    className: "payroll-summary-payment-modal-body-payment-notes"
  }, /*#__PURE__*/React.createElement("strong", null, "Payment Notes (Optional)")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    rows: 3,
    placeholder: "Add any notes about this payment...",
    className: "payroll-summary-payment-modal-body-text-area",
    value: paymentNote,
    onChange: function onChange(e) {
      return setPaymentNote(e.target.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between mt-4 mb-4 payroll-summary-payment-footer"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    onClick: onHide
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    disabled: paymentLoading || paymentTypeSelect === "partial-payment" && (Number(partialAmount) > payableAmount || Number(partialAmount) <= 0 || !partialAmount),
    onClick: function onClick() {
      if (paymentTypeSelect == "full-payment" || paymentTypeSelect === "partial-payment" && Number(partialAmount) <= payableAmount && Number(partialAmount) > 0) {
        paymentOnSubmit();
      }
    }
  }, paymentLoading ? "Loading.." : "Confirm Payment")))));
};
var ExportDetails = function ExportDetails(props) {
  var organisationSettings = props.organisationSettings,
    organisationId = props.organisationId,
    role = props.role,
    user = props.user,
    startUnix = props.startUnix,
    endUnix = props.endUnix,
    startDate = props.startDate,
    endDate = props.endDate,
    currencySymbol = props.currencySymbol,
    filterData = props.filterData,
    payabaleStatus = props.payabaleStatus,
    payrollPeriodLabel = props.payrollPeriodLabel;
  var _useLazyQuery13 = useLazyQuery(PAYROLL_SUMMARY_EXPORT_QUERY),
    _useLazyQuery14 = _slicedToArray(_useLazyQuery13, 2),
    getExport = _useLazyQuery14[0],
    _useLazyQuery14$ = _useLazyQuery14[1],
    exportLoading = _useLazyQuery14$.loading,
    exportData = _useLazyQuery14$.data;
  var getExportData = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            getExport({
              variables: {
                organisationId: organisationId,
                startDate: startUnix,
                endDate: endUnix ? endUnix : startUnix,
                searchText: null,
                userRole: role,
                timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                payrollCycle: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.payrollCycle
              }
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getExportData() {
      return _ref15.apply(this, arguments);
    };
  }();
  var csvData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var dataArray, dataValues, wb, ws, col, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dataArray = [];
          dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.payrollSummaryExport;
          if (dataValues) {
            _context4.next = 4;
            break;
          }
          return _context4.abrupt("return", []);
        case 4:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          col = [{
            header: "Employee",
            key: "employee",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Parameter",
            key: "parameter",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Salary Type",
            key: "salaryType",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Rate",
            key: "rate",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Billable Hours/Days",
            key: "totalHoursDays",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Non Billable Hours",
            key: "nonBillableHours",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          },
          // {
          //   header: "Adjustments",
          //   key: "adjustments",
          //   style: { alignment: { vertical: "middle", horizontal: "left" } },
          // },
          {
            header: "Total Earned",
            key: "totalEarned",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            // When payabaleStatus is false this cell holds the combined
            // "Payroll period … paid" message, so label it "Status".
            header: payabaleStatus ? "Total Paid" : "Status",
            key: "totalPaid",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }].concat(_toConsumableArray(payabaleStatus ? [{
            header: "Status",
            key: "status",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Pending",
            key: "pending",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }] : []));
          ws.columns = col;
          dataValues.map(function (payroll, index) {
            var user = payroll.user,
              salaryTypeValue = payroll.salaryType,
              salaryMetricValue = payroll.salaryMetric,
              rate = payroll.rate,
              totalHours = payroll.totalHours,
              totalEarned = payroll.totalEarned,
              status = payroll.status,
              totalDays = payroll.totalDays,
              remainingAmount = payroll.remainingAmount,
              paidAmount = payroll.paidAmount,
              adjustment = payroll.adjustment,
              nonBillableHours = payroll.nonBillableHours;
            var salaryTypeLabel = salaryType.find(function (type) {
              return type.value === salaryTypeValue;
            });
            var parameterLabel = salaryMetric.find(function (type) {
              return type.value === salaryMetricValue;
            });
            var rateLabel = rate ? "".concat(currencySymbol).concat(rate).concat(salaryTypeValue == "dayBased" ? "/day" : "/hr") : "-";
            var totalTime = salaryTypeValue == "hourlyBased" && totalHours ? totalHours : salaryTypeValue == "dayBased" && totalDays ? totalDays : "-";
            var totalEarnedValue = totalEarned ? "".concat(currencySymbol).concat(totalEarned.toLocaleString("en-IN")) : "".concat(currencySymbol, "0");
            // let adjustmentsValue = adjustment
            //   ? `${currencySymbol}${adjustment.toLocaleString("en-IN")}`
            //   : `${currencySymbol}0`;
            var paidValue = paidAmount ? "".concat(currencySymbol).concat(paidAmount.toLocaleString("en-IN")) : "".concat(currencySymbol, "0");
            var unpaidValue = remainingAmount ? "".concat(currencySymbol).concat(remainingAmount.toLocaleString("en-IN")) : "".concat(currencySymbol, "0");
            var payabaleStatus = (organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.payrollCycle) != null ? true : filterData == "Last Month" || filterData == "This Month" ? true : false;

            // Resolve the payroll period range (in unix ms) to show in the message cell.
            // - Custom range: use the selected start/end as-is.
            // - Same single day, or any filter other than This/Last Month: expand to the whole month.
            // - This Month / Last Month: already a full month range, use as-is.
            // Fall back to startUnix when endUnix is missing/invalid (single date selected),
            // otherwise moment(NaN) makes the period end NaN.
            var effectiveEndUnix = endUnix && !Number.isNaN(endUnix) ? endUnix : startUnix;
            var isSameDay = moment(startUnix).isSame(moment(effectiveEndUnix), "day");
            var periodStartUnix;
            var periodEndUnix;
            if (filterData == "Custom") {
              periodStartUnix = startUnix;
              periodEndUnix = effectiveEndUnix;
            } else if (isSameDay || filterData != "This Month" && filterData != "Last Month") {
              periodStartUnix = Number(moment(startUnix).startOf("month").format("x"));
              periodEndUnix = Number(moment(effectiveEndUnix).endOf("month").format("x"));
            } else {
              periodStartUnix = startUnix;
              periodEndUnix = effectiveEndUnix;
            }

            // If the resolved period spans more than one month, collapse it to a
            // single month (the end date's month) so the label never shows 2 months.
            if (!moment(periodStartUnix).isSame(moment(periodEndUnix), "month")) {
              periodStartUnix = Number(moment(periodEndUnix).startOf("month").format("x"));
              periodEndUnix = Number(moment(periodEndUnix).endOf("month").format("x"));
            }

            // e.g. "Payroll period (01 Jun - 30 Jun 2026)"
            var payrollPeriodLabel = "Payroll period (".concat(moment(periodStartUnix).format("DD MMM"), " - ").concat(moment(periodEndUnix).format("DD MMM YYYY"), ")");
            ws.addRow({
              employee: user.displayName,
              parameter: parameterLabel.label,
              salaryType: salaryTypeLabel.label,
              rate: rateLabel,
              totalHoursDays: totalTime,
              nonBillableHours: salaryTypeValue == "hourlyBased" ? "Not Applicable" : nonBillableHours,
              // adjustments: adjustmentsValue,
              totalEarned: totalEarnedValue,
              // When payabaleStatus is false the combined "Payroll period … paid"
              // message goes into the Total Paid cell.
              totalPaid: payabaleStatus ? paidValue : "".concat(payrollPeriodLabel, ": ").concat(paidValue, " paid."),
              status: status,
              // Pending column only exists when payabaleStatus is true; ignored otherwise.
              pending: unpaidValue
            });
          });
          ws.getRow(1).font = {
            bold: true
          };
          _context4.next = 12;
          return wb.xlsx.writeBuffer();
        case 12:
          buf = _context4.sent;
          fileName = "workfolio-payroll-summary-".concat(moment(startDate).format("DD-MMM-yyyy"), ".xlsx");
          if (endDate != null) {
            fileName = "workfolio-payroll-summary-".concat(moment(Number(startDate)).format("DD-MMM-yyyy"), "-").concat(moment(Number(endDate)).format("DD-MMM-yyyy"), ".xlsx");
          }
          saveAs(new Blob([buf]), fileName);
        case 16:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })), [exportData]);
  React.useEffect(function () {
    csvData();
  }, [exportData]);
  return (
    /*#__PURE__*/
    // <OverlayTrigger
    //   placement="bottom"
    //   overlay={
    //     <Tooltip id={`tooltip-bottom`} className="count-tooltip-start">
    //       Export is unavailable due to maintenance. It will be back within 24 hours. Sorry for the inconvenience.
    //     </Tooltip>
    //   }
    // >
    //   <div className="timesheet-export-button-header disable-timesheet">
    //     <HiDownload className="timesheet-download-icon" />
    //     Export
    //   </div>
    // </OverlayTrigger>
    React.createElement(Button, {
      variant: "outline-dark",
      className: "payroll-summary-header-export-button",
      onClick: function onClick() {
        return getExportData();
      }
    }, exportLoading ? "Loading..." : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiDownload, null), " Export"))
  );
};
export default PayrollCalculator;